import Swiper from 'swiper';
import { FreeMode } from 'swiper/modules';

const whyUsLogosSwiperComponent = (
	{
		swiperClass = '.js-logos',
		perView = 5.5,
		between = 70
	} = {}) => {
	const sliders = document.querySelectorAll(`${swiperClass} .swiper-wrapper`);
	if (!sliders.length) return;

	sliders.forEach((container) => {
		// Проверка: если уже клонировали (чтобы не дублировать)
		if (container.dataset.cloned) return;
		container.dataset.cloned = 'true';

		// 🔹 1. Клонируем слайды
		const slides = Array.from(container.children);
		const cloneCount = 3;

		for (let i = 0; i < cloneCount; i++) {
			slides.forEach((slide) => {
				const clone = slide.cloneNode(true);
				container.appendChild(clone);
			});
		}

		// 🔹 2. Инициализируем Swiper
		const swiper = new Swiper(container.closest(swiperClass), {
			modules: [FreeMode],
			slidesPerView: perView,
			spaceBetween: between,
			freeMode: {
				enabled: true,
				momentum: false,
			},
			allowTouchMove: false,
			loop: false,
		});

		// 🔹 3. Собственный плавный скролл
		let position = 0;
		const speed = 0.9;

		const tick = () => {
			position -= speed;

			const maxScroll = container.scrollWidth / 2;
			if (Math.abs(position) >= maxScroll) {
				position = 0;
			}

			container.style.transform = `translateX(${position}px)`;
			requestAnimationFrame(tick);
		};

		container.style.willChange = 'transform';
		tick();
	});
};

export default whyUsLogosSwiperComponent;
